import React from 'react';
import { Helmet } from 'react-helmet';

import '../scss/Elements/_tables.scss';
import { EquipLogsTableAxios } from '../components/Tables/EquipmentsLogsTable';

function EquipmentsLogs() {
  return (
    <div className='table-module-container'>
      <Helmet>
        <title>Logs de tipos de equipos</title>
      </Helmet>
      <div className='datatable'>
        <EquipLogsTableAxios />
      </div>
    </div>
  );
}

export default EquipmentsLogs;
